import { useCallback, useEffect, useState } from 'react';

import { findActiveMethylationReflexDraftForRequisition } from '@helpers/draftOrder';
import { fetchDraftOrders } from '@store/actions';

export function useActiveMethylationReflexDraftForRequisition(
  originalRequisitionId: string | undefined,
  enabled = true,
) {
  const [draftId, setDraftId] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    if (!originalRequisitionId || !enabled) {
      setDraftId(undefined);
      return;
    }

    setLoading(true);
    try {
      const drafts = await fetchDraftOrders();
      const activeDraft = findActiveMethylationReflexDraftForRequisition(drafts, originalRequisitionId);
      setDraftId(activeDraft?.identifier);
    } catch (err) {
      console.error('Error fetching draft orders for methylation reanalysis resume:', err);
      setDraftId(undefined);
    } finally {
      setLoading(false);
    }
  }, [enabled, originalRequisitionId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { draftId, loading, refetch };
}
